import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIn, setIn } from 'formik';

import SrUserSettingDropdown from 'client/components/SrUserSettingDropdown';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import UserActions from 'client/actions/User';
import branch from 'client/core/branch';

@branch({})
class SrUserSettingFilterListDropdown extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    optionsList: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    settingField: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    singleSelection: PropTypes.bool,
  };

  static defaultProps = {
    singleSelection: false,
  };

  constructor(props) {
    super(props);

    const settingValue = getIn(props.currentUser.settings, props.settingField);

    this.state = {
      settingValue: settingValue,
      settingValueTemporal: settingValue,
    };
  }

  _onChangeOptionId = (optionId) => {
    const { singleSelection } = this.props;
    const { settingValueTemporal } = this.state;

    if (optionId === undefined) {
      this.setState({ settingValueTemporal: undefined });
    } else if (Array.isArray(settingValueTemporal) && !singleSelection) {
      this.setState({
        settingValueTemporal: settingValueTemporal.includes(optionId)
          ? settingValueTemporal.filter((id) => id !== optionId)
          : [...settingValueTemporal, optionId],
      });
    } else {
      this.setState({
        settingValueTemporal: settingValueTemporal ? [settingValueTemporal, optionId] : [optionId],
      });
    }
  };

  _onSaveOptionId = () => {
    const { currentUser, settingField, dispatch } = this.props;
    const { settingValueTemporal } = this.state;
    const newUserSettings = setIn({ ...currentUser.settings }, settingField, settingValueTemporal);

    this.setState({ settingValue: settingValueTemporal });
    dispatch(UserActions.updateSettings, newUserSettings);
  };

  render() {
    const { settingField, currentUser, optionsList, dispatch, placeholder } = this.props;

    const { settingValue, settingValueTemporal } = this.state;

    const options = [
      {
        label: 'all',
        value: undefined,
      },
      ...(optionsList || []).map((option) => ({
        label: option.name,
        value: option.id,
      })),
    ];

    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];
    const optionsActive = options
      .filter((option) => settingValueArray.includes(option.value))
      .map(({ label }) => label)
      .join(', ');
    const title = `${placeholder}: ${optionsActive || '...'}`;

    return (
      <SrUserSettingDropdown
        user={currentUser}
        settingField={settingField}
        settingValue={settingValueTemporal}
        title={title}
        options={options}
        onChange={this._onChangeOptionId}
        dispatch={dispatch}
        shouldUpdateSettings={false}
        multiple
        footer={
          <div className="buttonContainer">
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE}
              type="button"
              onClick={this._onSaveOptionId}
            >
              save
            </ButtonDeprecated>
          </div>
        }
      />
    );
  }
}

SrUserSettingFilterListDropdown.displayName = 'SrUserSettingFilterListDropdown';

export default SrUserSettingFilterListDropdown;
